<template>
  <section class="product-detail-content">
    <section class="overview-section">
      <div class="overview-hero">
        <div class="overview-copy">
          <p class="overview-label">{{ pageData.overview.label }}</p>
          <h2>{{ pageData.overview.title }}</h2>
          <p>{{ pageData.overview.description }}</p>
          <div class="overview-tags">
            <span v-for="tag in pageData.overview.tags" :key="tag">{{ tag }}</span>
          </div>
        </div>
        <div class="overview-panel" aria-hidden="true">
          <div class="panel-title"><span></span>{{ pageData.overview.panel.title }}</div>
          <div class="panel-summary"><strong>{{ pageData.overview.panel.summaryLabel }}</strong><span>{{ pageData.overview.panel.summaryValue }}</span></div>
          <div v-for="row in pageData.overview.panel.rows" :key="row.label" :class="'panel-row--' + row.tone" class="panel-row">
            <span>{{ row.label }}</span>
            <strong>{{ row.value }}</strong>
          </div>
          <div class="panel-footer">{{ pageData.overview.panel.footer }}</div>
        </div>
      </div>
<!--      <div class="value-list">-->
<!--        <article v-for="value in pageData.overview.values" :key="value.title" class="value-item">-->
<!--          <h3>{{ value.title }}</h3>-->
<!--          <p>{{ value.description }}</p>-->
<!--        </article>-->
<!--      </div>-->
    </section>

    <section class="capabilities-section">
      <header class="section-heading">
        <h2>{{ pageData.featureSection.title }}</h2>
        <p>{{ pageData.featureSection.description }}</p>
      </header>

      <article v-for="(feature, index) in featureList" :key="feature.feature" :class="{ 'is-reverse': index % 2 === 1 }" class="feature-block">
        <div class="feature-copy">
          <h3>{{ feature.feature }}</h3>
          <ul>
            <li v-for="item in feature.description" :key="item">{{ item }}</li>
          </ul>
        </div>
        <div class="feature-visual">
          <img :src="feature.src2" :alt="feature.feature + '界面示例'" />
        </div>
      </article>
    </section>

    <section class="process-section">
      <header class="section-heading process-heading">
        <h2>{{ pageData.process.title }}</h2>
        <p>{{ pageData.process.description }}</p>
      </header>
      <div :class="'process-list--' + pageData.process.steps.length" class="process-list">
        <article v-for="step in pageData.process.steps" :key="step.title" class="process-step">
          <h3>{{ step.title }}</h3>
          <p>{{ step.description }}</p>
        </article>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'ProductModel',
  props: {
    featureList: {
      type: Array,
      required: true
    },
    pageData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.product-detail-content { background: #fff; color: #20344e; }
.overview-section, .capabilities-section, .process-section { padding: 80px max(24px, calc((100vw - 1200px) / 2)); }
.overview-section { background: #f5f9ff; }
.overview-hero { display: grid; grid-template-columns: minmax(0, 1fr) 330px; align-items: center; gap: 72px; }
.overview-copy { max-width: 620px; }
.overview-label { margin: 0 0 14px; color: #1f5dea; font-size: 13px; font-weight: 600; }
.overview-copy h2, .section-heading h2 { margin: 0; color: #20344e; font-size: 32px; font-weight: 600; line-height: 1.45; }
.overview-copy > p:not(.overview-label) { margin: 18px 0 0; color: #6c7d91; font-size: 15px; line-height: 1.9; }
.overview-tags { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 26px; }
.overview-tags span { padding: 8px 15px; border: 1px solid #d7e4fb; border-radius: 3px; background: #fff; color: #3866a9; font-size: 13px; }
.overview-panel { padding: 26px; border: 1px solid #dce8f8; border-radius: 6px; background: #fff; box-shadow: 0 16px 35px rgba(49, 91, 147, .1); }
.panel-title { display: flex; align-items: center; gap: 9px; color: #38506d; font-size: 15px; font-weight: 600; }
.panel-title span { width: 8px; height: 8px; border-radius: 50%; background: #2e73e8; }
.panel-summary, .panel-row { display: flex; align-items: center; justify-content: space-between; }
.panel-summary { margin-top: 25px; padding: 13px 14px; background: #f4f8ff; color: #637995; font-size: 12px; }
.panel-summary strong { color: #38506d; font-weight: 500; }
.panel-summary span { color: #2e73e8; font-size: 15px; font-weight: 600; }
.panel-row { margin-top: 16px; padding-bottom: 12px; border-bottom: 1px solid #eef2f8; color: #75869a; font-size: 12px; }
.panel-row strong { font-weight: 500; }
.panel-row--primary strong { color: #2e73e8; }
.panel-row--positive strong { color: #23a47a; }
.panel-row--warning strong { color: #d07832; }
.panel-footer { margin-top: 19px; padding-top: 14px; border-top: 1px solid #eef2f8; color: #8c9bae; font-size: 11px; line-height: 1.6; }
.value-list { display: grid; grid-template-columns: repeat(3, 1fr); margin-top: 58px; border-top: 1px solid #dce7f5; border-bottom: 1px solid #dce7f5; }
.value-item { min-height: 132px; padding: 21px 20px; border-right: 1px solid #dce7f5; }
.value-item:first-child { padding-left: 0; }
.value-item:last-child { border-right: 0; }
.value-item h3 { margin: 0; color: #2e73e8; font-size: 18px; font-weight: 600; line-height: 1.5; }
.value-item p { margin: 10px 0 0; color: #718399; font-size: 12px; line-height: 1.7; }
.capabilities-section { padding-bottom: 0; }
.section-heading { max-width: 700px; margin: 0 auto 50px; text-align: center; }
.section-heading > p { margin: 16px 0 0; color: #8290a1; font-size: 15px; line-height: 1.85; }
.feature-block { display: grid; width: 100vw; grid-template-columns: minmax(280px, .7fr) minmax(0, 1.3fr); align-items: center; gap: clamp(38px, 7vw, 96px); padding: 76px max(24px, calc((100vw - 1200px) / 2)); margin-left: calc(50% - 50vw); background: #fff; }
.feature-block.is-reverse { grid-template-columns: minmax(0, 1.3fr) minmax(280px, .7fr); background: #f7faff; }
.feature-block.is-reverse .feature-copy { grid-column: 2; }
.feature-block.is-reverse .feature-visual { grid-column: 1; grid-row: 1; }
.feature-copy { max-width: 410px; }
.feature-copy h3 { margin: 0; color: #263e5d; font-size: 25px; font-weight: 600; line-height: 1.5; }
.feature-copy ul { margin: 23px 0 0; padding: 16px 0 0 18px; border-top: 1px solid #dfe8f3; color: #59718f; }
.feature-copy li { margin-bottom: 12px; font-size: 14px; line-height: 1.85; }
.feature-copy li:last-child { margin-bottom: 0; }
.feature-visual { overflow: hidden; border: 1px solid #dce8f8; border-radius: 6px; background: #fff; box-shadow: 0 16px 34px rgba(43, 82, 132, .11); transition: transform .25s ease, box-shadow .25s ease; }
.feature-block:hover .feature-visual { transform: translateY(-4px); box-shadow: 0 22px 40px rgba(43, 82, 132, .14); }
.feature-visual img { display: block; width: 100%; height: auto; }
.process-section { background: #f5f9ff; }
.process-heading { margin-bottom: 42px; }
.process-list { display: grid; gap: 0; }
.process-list--3 { grid-template-columns: repeat(3, 1fr); }
.process-list--4 { grid-template-columns: repeat(4, 1fr); }
.process-step { position: relative; min-height: 116px; padding: 0 30px 0 0; }
.process-step:not(:last-child)::after { position: absolute; top: 13px; right: 14px; width: 1px; height: 64px; background: #cadcf4; content: ''; }
.process-step h3 { margin: 0 0 12px; color: #2b4564; font-size: 18px; font-weight: 600; line-height: 1.5; }
.process-step p { max-width: 230px; margin: 0; color: #77879a; font-size: 14px; line-height: 1.8; }
@media (max-width: 1000px) {
  .overview-hero { gap: 45px; }
  .value-item { padding-right: 15px; padding-left: 15px; }
  .feature-block, .feature-block.is-reverse { grid-template-columns: minmax(240px, .8fr) minmax(0, 1.2fr); gap: 42px; }
  .feature-copy h3 { font-size: 22px; }
}
@media (max-width: 780px) {
  .overview-hero { grid-template-columns: 1fr; gap: 34px; }
  .overview-copy { max-width: none; }
  .feature-block, .feature-block.is-reverse { display: flex; flex-direction: column; align-items: stretch; gap: 30px; padding-top: 58px; padding-bottom: 58px; }
  .feature-block.is-reverse .feature-copy, .feature-block.is-reverse .feature-visual { grid-column: auto; grid-row: auto; }
  .feature-copy { max-width: none; }
  .feature-block.is-reverse .feature-copy { order: 0; }
  .feature-block.is-reverse .feature-visual { order: 1; }
  .process-list--3, .process-list--4 { grid-template-columns: repeat(2, 1fr); gap: 30px 24px; }
  .process-step:nth-child(2)::after { display: none; }
}
@media (max-width: 650px) {
  .overview-section, .capabilities-section, .process-section { padding: 58px 20px; }
  .overview-copy h2, .section-heading h2 { font-size: 25px; }
  .overview-copy > p:not(.overview-label), .section-heading > p { font-size: 14px; }
  .overview-panel { width: 100%; box-sizing: border-box; padding: 22px 20px; }
  .overview-tags { gap: 8px; }
  .overview-tags span { padding: 7px 12px; font-size: 12px; }
  .value-list { display: block; margin-top: 38px; }
  .value-item, .value-item:first-child { min-height: 0; padding: 18px 0; border-right: 0; border-bottom: 1px solid #dce7f5; }
  .value-item:last-child { border-bottom: 0; }
  .feature-block, .feature-block.is-reverse { gap: 26px; padding: 52px 20px; margin-right: 0; margin-left: calc(50% - 50vw); }
  .feature-copy h3 { font-size: 21px; }
  .feature-copy li { font-size: 14px; line-height: 1.75; }
  .process-list--3, .process-list--4 { grid-template-columns: 1fr; gap: 0; }
  .process-step { min-height: 0; padding: 0 0 26px 20px; border-left: 1px solid #cadcf4; }
  .process-step:not(:last-child)::after { display: none; }
  .process-step:last-child { padding-bottom: 0; }
  .process-step h3 { font-size: 17px; }
  .process-step p { max-width: none; font-size: 13px; }
}
@media (prefers-reduced-motion: reduce) {
  .feature-visual { transition: none; }
}
</style>
